const SentCorrelationIds: string[] = [];

export default SentCorrelationIds;
